import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["offering", "price", "since", "till"]

  connect() {
    this.syncPrice()
  }

  syncFromOffering() {
    this.syncPrice({ overwrite: true })
    this.updateTill()
  }

  syncPrice({ overwrite = false } = {}) {
    if (!this.hasOfferingTarget || !this.hasPriceTarget) return

    const option = this.offeringTarget.selectedOptions[0]
    if (!option?.dataset.price) return
    if (!overwrite && this.priceTarget.value) return

    this.priceTarget.value = option.dataset.price
  }

  updateTill() {
    if (!this.hasOfferingTarget || !this.hasSinceTarget || !this.hasTillTarget) return

    const option = this.offeringTarget.selectedOptions[0]
    const minutes = Number(option?.dataset.duration)
    if (!minutes || !this.sinceTarget.value) return

    const start = new Date(this.sinceTarget.value)
    if (Number.isNaN(start.getTime())) return

    start.setMinutes(start.getMinutes() + minutes)
    this.tillTarget.value = this.toLocalValue(start)
  }

  toLocalValue(date) {
    const pad = (value) => String(value).padStart(2, "0")
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
  }
}
